module.exports = __webpack_public_path__ + "static/img/-s-1.a50150a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-s-1.png
// module id = r7HW
// module chunks = 0